import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import { ListingTier, PrimeItemAdapter } from '@propertypal/shared/src/types/prime';
import React from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../../typography';
import {
  PrimeOverlayContainer,
  PrimeOverlayExpire,
  PrimeOverlayHeader,
  OverlayUpgradeBox,
  UpgradeHeader,
  UpgradeText,
} from './PrimeOverlay.style';

interface PrimeOverlayProps {
  current: ListingTier;
  tier?: ListingTier;
  currentPrimeItem?: PrimeItemAdapter;
}

const PrimeOverlay: React.FC<PrimeOverlayProps> = ({ current, tier, currentPrimeItem }) => {
  const theme = useTheme();

  const colour = theme?.prime[current];

  return (
    <PrimeOverlayContainer data-testid="prime-overlay" $tier={!!tier} $gold={current === 'GOLD'}>
      <PrimeOverlayHeader $tier={!!tier}>
        This property has already been upgraded to{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          Prime | <b style={{ color: colour }}>{current}</b>.
        </span>
      </PrimeOverlayHeader>
      {currentPrimeItem && currentPrimeItem.expiryTime && currentPrimeItem.daysRemaining && (
        <PrimeOverlayExpire $tier={!!tier} data-testid="prime-overlay-expiry">
          <span>The upgrade will expire in </span>
          <span>
            <b>{currentPrimeItem.daysRemaining} days</b> on{' '}
            <b>{parseApiDate(currentPrimeItem.expiryTime).format('Do MMMM YYYY')}</b>.
          </span>
        </PrimeOverlayExpire>
      )}
      {current === 'GOLD' && (
        <Text align="center" mt={12} data-testid="prime-gold-text" color={theme.textDark}>
          You&apos;ll be able to upgrade your property again at that time.
        </Text>
      )}
      {tier && (
        <OverlayUpgradeBox $color={colour} data-testid="prime-upgrade-box">
          <UpgradeHeader>Ready for More Exposure?</UpgradeHeader>
          <UpgradeText>
            <span>
              Upgrade to{' '}
              {tier === 'BRONZE' && (
                <>
                  <b data-testid="prime-silver-text" style={{ color: theme.prime.SILVER }}>
                    Silver
                  </b>{' '}
                  or{' '}
                </>
              )}
              <b style={{ color: theme.prime.GOLD }}>Gold</b> today and get a bigger listing, more visibility, and more
              impact.
            </span>

            <span>
              <b>Best part?</b> You only pay the difference - not the full price.
            </span>
          </UpgradeText>
        </OverlayUpgradeBox>
      )}
    </PrimeOverlayContainer>
  );
};

export default PrimeOverlay;
